const redes = [
    {
        "id": 1,
        "name": "Linkedin",
        "link": "https://www.linkedin.com/in/lorenacohenebaez/",
        "icon": "bi bi-linkedin",
    },
    {
        "id": 2,
        "name": "Gmail",
        "link": "mailto:lorenacohenebaez@gmail.com",
        "icon": "bi bi-envelope-open-fill",
    },
    {
        "id": 3,
        "name": "Github",
        "link": "https://github.com/LorenaCoheneBaez",
        "icon": "bi bi-github",
    },
]

export default redes